// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"G_b0","open":"G_b1","hasResults":"G_bV","shortcut":"G_b2","searchInput":"G_b3","searchIcon":"G_b4"};